/*
 * DEPRECATED
 * Use api configured actions instead
 */
import { Component } from 'vue';

import NxEntityToolDelete from '@/modules/entity/tools/ToolDelete.vue';
import NxEntityToolUnpublish from '@/modules/entity/tools/ToolUnpublish.vue';

const remove: IEntityToolConfig = {
  name: 'delete',
  component: NxEntityToolDelete,
  icon: 'delete',
};
const unpublish: IEntityToolConfig = {
  name: 'unpublish',
  component: NxEntityToolUnpublish,
  icon: 'file_download',
};

const Tools: ITools = {
  tag: {
    // Disable fake merge
    // merge,
    delete: remove,
  },
  alert: {
    unpublish,
  },
  sitePaywall: {
    unpublish,
  },
  twitterApp: {
    delete: remove,
  },
  facebookApp: {
    delete: remove,
  },
  twitterAccount: {
    delete: remove,
  },
  facebookAccount: {
    delete: remove,
  },
};

export default Tools;

interface ITools {
  [entityName: string]: IEntityTools;
}

interface IEntityTools {
  [name: string]: IEntityToolConfig,
}

interface IEntityToolConfig {
  name: string,
  component: Component,
  icon: string,
}

export enum Actions {
  NONE = '',
  MERGE = 'merge',
  DELETE = 'delete',
  UNPUBLISH = 'unpublish',
}
